import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

function Unavailable() {
    const { t } = useTranslation()
    return (
        <div role="alert" data-testid="extension-unavailable" className="p-8 text-[var(--text-weak)]">
            {t('extension.unavailable')}
        </div>
    )
}

interface Props {
    /** Extension view id, for the log. */
    viewId: string
    children: ReactNode
}

/** Keeps a failing extension view from taking down the shell. */
export class ExtensionBoundary extends Component<Props, { failed: boolean }> {
    state = { failed: false }

    static getDerivedStateFromError() {
        return { failed: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error(`[extensions] view "${this.props.viewId}" crashed`, error, info.componentStack)
    }

    render() {
        return this.state.failed ? <Unavailable /> : this.props.children
    }
}
